<template>
  <div>
    <el-form>
      <el-card v-if="step === 1">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
            icon="menu"
            prop="matrix_level">
              <p>{{$t('Nombre flujo de aprobación')}}</p>
              <el-input
                v-model="workflow.name"
                size="medium">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
            icon="menu"
            prop="matrix_level">
              <p>{{$t('Niveles de riesgo')}}</p>
              <el-input-number
                v-model="risksLevels"
                size="medium"
                :min="1"
                :disabled="true"
                :max="15">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <div v-if="step === 2">
        <div slot="header" class="clearfix">
          <span style="line-height: 36px;">
            {{$t('Definir flujos de aprobación de riesgos')}}
          </span>
        </div>
        <br>
        <WorkflowCreateRisk
          v-for="(risk, level) in workflow.risks"
          v-bind:key="level"
          :risk="risk" />
      </div>

      <div v-if="step === 3">
        <div slot="header" class="clearfix">
          <span style="line-height: 36px;">{{$t('Resumen')}}</span>
        </div>
        <br>
        <Workflow
          :workflow="workflow"
          :params="{'description_only': true}">
        </Workflow>
      </div>
    </el-form>
  </div>
</template>

<script>
import Workflow from '@/components/workflows/Workflow.vue';
import WorkflowCreateRisk from '@/components/workflows/WorkflowCreateRisk.vue';

export default {
  name: 'createWorkflow',
  components: {
    Workflow,
    WorkflowCreateRisk,
  },
  props: [
    'step',
    'workflow',
  ],
  data() {
    return {
      risksLevels: this.workflow.risks.length,
    };
  },
  watch: {
    step: {
      handler(val, oldVal) {
        if (oldVal === 1 && val === 2) {
          this.setRisks();
        }
      },
    },
  },
  created() {
    this.risksLevels = 5;
    this.setRisks();
  },
  methods: {
    setRisks() {
      const currentRisksLevels = this.workflow.risks.length;
      const diff = this.risksLevels - currentRisksLevels;

      if (diff > 0) {
        for (let i = 1; i <= diff; i++) {
          this.workflow.risks.push([{
            riskLevel: currentRisksLevels + i,
            totalPeople: 1,
            minToApprove: 1,
            returnTo: 0,
            peopleProfile: [
              null,
            ],
            people: [
              null,
            ],
          }]);
        }
      } else if (diff < 0) {
        this.workflow.risks.splice(diff, this.workflow.risks.length - 1);
      }
    },
  },
};
</script>
